export enum FileParsingStatus {
  PROGRESS = 'progress',
  FAILED = 'failed',
  SUCCESS = 'success',
}

export interface IObjectType {
  objectTypeId: string;
  name: string;
  version: number | string;
}

export type TCommonTableCell = number | string;

export interface ICommonTable {
  headers: string[],
  units: string[],
  rows: TCommonTableCell[][],
  quantities?: string[],
  tooltips?: (string | string[])[],
}
